// extracted by mini-css-extract-plugin
module.exports = {"metaItem":"MetaItem_metaItem__7ZSkb","metaTitle":"MetaItem_metaTitle__Z4GGN","metaValue":"MetaItem_metaValue__kYsMz"};